import { normalize } from 'normalizr';

import fetchService from 'common/actions/fetchService';
import updateEntities from 'common/actions/updateEntities';
import busPaxManifestPassengerSchema from 'modules/bus/pax-manifest/shared/schemas/busPaxManifestPassengerSchema';
import TemporarySystemDisruptionException from 'common/exceptions/TemporarySystemDisruptionException';
import i18n from 'common/locale/i18n';
import UnavailableRouteException from 'common/exceptions/UnavailableRouteException';
import busPaxManifestMarkerSchema from '../../shared/schemas/busPaxManifestMarkerSchema';

export const PAX_MANIFEST_FETCH_DETAIL = 'PAX_MANIFEST_FETCH_DETAIL';
export default function fetchPaxManifestDetailAction(spec) {
  return function thunk(dispatch, getState) {
    return dispatch(
      fetchService(({ pssService }) =>
        pssService.fetch(
          'POST',
          '/api/v2/busextranetoperator/manifest/getDetail',
          spec
        )
      )
    )
      .catch(() => {
        throw new TemporarySystemDisruptionException(
          i18n.getText('error_temporary_disruption_message'),
          {
            title: i18n.getText('error_temporary_disruption_title'),
          }
        );
      })
      .then(({ result }) => {
        if (result.data.passengers.length === 0) {
          throw new UnavailableRouteException(result.data.message, {
            title: i18n.getText('error_unavailable_route_title'),
            hideCtaButton: true,
          });
        }
        const { entities, result: entityIds } = normalize(
          result.data.passengers,
          [busPaxManifestPassengerSchema]
        );
        dispatch(updateEntities(entities));

        const {
          entities: markerDataEntities,
          result: markerDataEntityIds,
        } = normalize(result.data.markerDatas, [busPaxManifestMarkerSchema]);
        dispatch(updateEntities(markerDataEntities));

        dispatch({
          type: PAX_MANIFEST_FETCH_DETAIL,
          payload: {
            ...result.data,
            passengers: entityIds,
            markerDatas: markerDataEntityIds,
            vessel: result.data.vessel,
          },
        });
      });
  };
}
